import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d074128"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "study-material-detail-top"
};
const _hoisted_2 = {
  class: "image-wrapper"
};
const _hoisted_3 = {
  class: "cover-image"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "detail-info"
};
const _hoisted_6 = {
  class: "title-section"
};
const _hoisted_7 = {
  class: "material-name"
};
const _hoisted_8 = {
  class: "tag-box"
};
const _hoisted_9 = {
  class: "description-box"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-label"
}, "📖 资料简介", -1));
const _hoisted_11 = {
  class: "description-text"
};
const _hoisted_12 = ["href"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看完整介绍", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1));
const _hoisted_15 = {
  class: "price-box"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "price-label"
}, "价格", -1));
const _hoisted_17 = {
  class: "price-content"
};
const _hoisted_18 = {
  key: 0,
  class: "free-display"
};
const _hoisted_19 = {
  class: "free-badge"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "free-text"
}, "免费", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "free-tip"
}, "无需付费，登录后即可直接获取完整资料", -1));
const _hoisted_22 = {
  class: "price-display"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "currency"
}, "¥", -1));
const _hoisted_24 = {
  class: "amount"
};
const _hoisted_25 = {
  key: 0,
  class: "member-discount"
};
const _hoisted_26 = {
  class: "action-box"
};
const _hoisted_27 = {
  class: "agreement-wrapper"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "agreement-links"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/agreement/userAgreement.html",
  target: "_blank"
}, "用户协议"), /*#__PURE__*/_createTextVNode(" · "), /*#__PURE__*/_createElementVNode("a", {
  href: "/agreement/payAgreement.html",
  target: "_blank"
}, "购买协议"), /*#__PURE__*/_createTextVNode(" · "), /*#__PURE__*/_createElementVNode("a", {
  href: "/agreement/privacyAgreement.html",
  target: "_blank"
}, "隐私政策")], -1));
const _hoisted_29 = {
  class: "button-group"
};
import { computed, ref, watch } from 'vue';
import { ClockCircleOutlined, EyeOutlined, GiftOutlined, LinkOutlined, ShoppingCartOutlined, ShoppingOutlined, WechatOutlined, TagOutlined } from '@ant-design/icons-vue';
import dayjs from "dayjs";
import { XiaoniuStudyMaterialControllerService } from "../../../../generated/services/XiaoniuStudyMaterialControllerService";
import { message, Modal } from "ant-design-vue";
import { useLoginUserStore } from "@/store/loginUser";
import ACCESS_ENUM from "@/access/ACCESS_ENUM";
// 本地默认封面（项目内置），与列表卡片共用同一张图，保证视觉一致
import defaultCoverImage from '@/assets/default-project-image.png';
const TEST_MODE_KEY = 'study_material_test_mode';
export default /*#__PURE__*/_defineComponent({
  __name: 'StudyMaterialDetailTop',
  props: {
    materialDetail: {},
    viewCount: {},
    buyCount: {}
  },
  emits: ["order-success"],
  setup(__props, {
    emit: __emit
  }) {
    const loginUserStore = useLoginUserStore();
    const agreementChecked = ref(false);
    const isClickBuy = ref(false);
    const buyButtonText = ref('立即购买');
    const formattedCreateDate = ref('');
    const formattedViewCount = ref('0');
    const formattedBuyCount = ref('0');
    // 详情页只有一张封面图，用一个布尔位记录是否已加载，控制淡入避免闪烁
    const imageLoaded = ref(false);
    const props = __props;
    // 仅当父组件传入的 materialDetail 拿到真实数据（非初始空对象 {}）时，才视为可渲染封面
    // 这避免了在接口返回前，img.src 因空数据落到 defaultCoverImage 而闪现默认图
    const hasDetailData = computed(() => !!props.materialDetail && Object.keys(props.materialDetail).length > 0);
    // materialDetail 每次更新（包括首次接口返回、后续切换/刷新），重置 imageLoaded 让封面图重新淡入
    watch(() => props.materialDetail, () => {
      imageLoaded.value = false;
    }, {
      deep: true
    });
    const markLoaded = () => {
      imageLoaded.value = true;
    };
    const getImageUrl = item => {
      // 优先用接口返回的封面；为空时直接走本地默认图
      return !item.coverImage || item.coverImage === '' ? defaultCoverImage : item.coverImage;
    };
    // 远程图片加载失败（404 / 网络异常）时回退到本地默认图，避免封面空白
    // 切到默认图时也重置 imageLoaded，让默认图重新走一次淡入，避免破图图标短暂残留
    const onImgError = e => {
      const img = e.target;
      if (img && img.src !== defaultCoverImage) {
        img.src = defaultCoverImage;
        imageLoaded.value = false;
      }
    };
    // 下单成功后通知父组件刷新买量（免费资料此时 buyCount 已 +1，需要拉最新值）
    const emit = __emit;
    watch([() => props.materialDetail, () => props.viewCount, () => props.buyCount], ([newDetail, newViewCount, newBuyCount]) => {
      if (newDetail && newDetail.createTime) {
        formattedCreateDate.value = dayjs(newDetail.createTime).format('YYYY-MM-DD');
      }
      if (newDetail) {
        buyButtonText.value = Number(newDetail.price) === 0 ? '立即获取' : '立即购买';
      }
      if (newViewCount !== undefined && newViewCount !== null) {
        formattedViewCount.value = newViewCount > 10000 ? (newViewCount / 10000).toFixed(2) + '万' : newViewCount.toString();
      }
      if (newBuyCount !== undefined && newBuyCount !== null) {
        formattedBuyCount.value = newBuyCount > 10000 ? (newBuyCount / 10000).toFixed(2) + '万' : newBuyCount.toString();
      }
    }, {
      immediate: true
    });
    // 用于测试下单的本地模拟
    const simulateLocalOrder = () => {
      const orderNo = 'TEST' + Date.now().toString().slice(-10);
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            code: 200,
            data: orderNo
          });
        }, 600);
      });
    };
    const startCountdown = async () => {
      let countdown = 3;
      buyButtonText.value = `正在为您下单中...${countdown}秒`;
      isClickBuy.value = true;
      const interval = setInterval(async () => {
        countdown -= 1;
        buyButtonText.value = `正在为您下单中...${countdown}秒`;
        if (countdown <= 0) {
          clearInterval(interval);
          try {
            const orderRes = await XiaoniuStudyMaterialControllerService.addOrderUsingPost(props.materialDetail);
            if (orderRes.code === 200) {
              // 通知父组件刷新 buyCount（免费资料已由后端 +1）
              emit('order-success');
              if (orderRes.data.num === "0") {
                message.success("下单成功,请到我的订单界面查收~");
                resetButton();
                return;
              }
              const payRes = await XiaoniuStudyMaterialControllerService.payOrderUsingPost(orderRes.data.orderNo);
              if (payRes?.paymentUrl) {
                window.location = payRes.paymentUrl;
              } else {
                message.success('下单成功，请到订单中心查看~');
                resetButton();
              }
            } else {
              message.error(orderRes.msg || '下单失败');
              resetButton();
            }
          } catch (error) {
            console.error('下单异常:', error);
            resetButton();
          }
        }
      }, 1000);
    };
    const resetButton = () => {
      isClickBuy.value = false;
      buyButtonText.value = Number(props.materialDetail.price) === 0 ? '立即获取' : '立即购买';
    };
    const buy = () => {
      if (!loginUserStore.isLogin) {
        message.error('您尚未登录~');
        return;
      }
      if (!agreementChecked.value) {
        message.error('请先勾选并同意协议~');
        return;
      }
      startCountdown();
    };
    const contactCustomer = () => {
      Modal.info({
        title: '联系客服',
        content: () => '请联系客服微信：xiaoniuzui6',
        okText: '我知道了'
      });
    };
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 30
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 11,
          lg: 11,
          xl: 11
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [hasDetailData.value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: getImageUrl(_ctx.materialDetail),
            alt: "封面图",
            class: _normalizeClass(["cover-image-inner", {
              'is-loaded': imageLoaded.value
            }]),
            onLoad: markLoaded,
            onError: onImgError
          }, null, 42, _hoisted_4)) : _createCommentVNode("", true)])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          sm: 24,
          md: 13,
          lg: 13,
          xl: 13
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.materialDetail.name), 1), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_tag, {
            type: "primary",
            class: "custom-tag"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ClockCircleOutlined), {
              class: "tag-icon"
            }), _createTextVNode(" 发布" + _toDisplayString(formattedCreateDate.value), 1)]),
            _: 1
          }), _createVNode(_component_el_tag, {
            type: "success",
            class: "custom-tag"
          }, {
            default: _withCtx(() => [_createVNode(_unref(EyeOutlined), {
              class: "tag-icon"
            }), _createTextVNode(" 浏览" + _toDisplayString(formattedViewCount.value) + "次 ", 1)]),
            _: 1
          }), _createVNode(_component_el_tag, {
            type: "warning",
            class: "custom-tag"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ShoppingCartOutlined), {
              class: "tag-icon"
            }), _createTextVNode(" 购买" + _toDisplayString(formattedBuyCount.value) + "次 ", 1)]),
            _: 1
          })])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.materialDetail.description || '这是一份精心整理的学习资料，欢迎购买查看~'), 1), _ctx.materialDetail.introUrl ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.materialDetail.introUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "intro-link"
          }, [_createVNode(_unref(LinkOutlined)), _hoisted_13], 8, _hoisted_12)) : _createCommentVNode("", true)]), _hoisted_14, _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [Number(_ctx.materialDetail.price) === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_unref(GiftOutlined), {
            class: "free-icon"
          }), _hoisted_20]), _hoisted_21])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.materialDetail.price), 1)]), _unref(loginUserStore).loginUser?.userRole === _unref(ACCESS_ENUM).VIP ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_unref(TagOutlined), {
            class: "member-icon"
          }), _createTextVNode(" 会员已开通，可享专属优惠 ")])) : _createCommentVNode("", true)], 64))])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_el_checkbox, {
            modelValue: agreementChecked.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => agreementChecked.value = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("我已阅读并同意平台")]),
            _: 1
          }, 8, ["modelValue"]), _hoisted_28]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
            type: "primary",
            size: "large",
            class: "buy-btn",
            loading: isClickBuy.value,
            onClick: buy
          }, {
            icon: _withCtx(() => [_createVNode(_unref(ShoppingOutlined))]),
            default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(buyButtonText.value), 1)]),
            _: 1
          }, 8, ["loading"]), _createVNode(_component_el_button, {
            size: "large",
            class: "contact-btn",
            onClick: contactCustomer
          }, {
            icon: _withCtx(() => [_createVNode(_unref(WechatOutlined))]),
            default: _withCtx(() => [_createTextVNode(" 联系客服 ")]),
            _: 1
          })])])])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});